import { createSlice } from '@reduxjs/toolkit';
export const statusInitialState = {
    isEditing: false,
    isPublishing: false
};
const statusSlice = createSlice({
    name: 'status',
    initialState: statusInitialState,
    reducers: {
        setIsEditing: (state, action) => {
            state.isEditing = action.payload;
        },
        setIsPublishing: (state, action) => {
            state.isPublishing = action.payload;
        }
    }
});
export const { setIsEditing, setIsPublishing } = statusSlice.actions;
export default statusSlice.reducer;
